import { SwipeAction } from "antd-mobile";

export default SwipeAction;
